import { render, staticRenderFns } from "./OALogin.vue?vue&type=template&id=4306cec3&scoped=true"
import script from "./OALogin.vue?vue&type=script&lang=js"
export * from "./OALogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306cec3",
  null
  
)

export default component.exports